import React from "react";
import "./about.css"

const About = () => {


    return (

        <section className='contact-form' id="About1">
            <h1 class="heading">
                <span>A</span>
                <span>B</span>
                <span>O</span>
                <span>U</span>
                <span>T</span>
                <span>M</span>
                <span>E</span>


            </h1>
            <div className="about-us-container">
                <div className="about-us-detail">
                    <div className="image-data" data-aos="fade-right">
                        <img src="/images/ak .png" alt=""></img>
                    </div>
                    
                    <div className="s">
                    <div className="about-myself">
                       <p>Hello Everyone😊,I am Ashutosh Kumar currently in pref-final year Pursuing my btech from Bhagwan Paeshuram Institute of technology(Part of GGSIPU).</p>
                      <p>I am enthusaitc dedicated engineer who love to explore and experiment about the new technology,having good problem solving skilss and would love to work with people to grow and learn together.</p>
                        </div>
                      <div className="sss">
                      <a href='https://m.facebook.com/ashutoshkumar.kumar.96' target='_blank'  rel="noreferrer"><i className='fab fa-facebook-f'></i></a>
               
                      
                      <a href='https://www.codechef.com/users/ashu_1244' target='blank'><iconify-icon icon="simple-icons:codechef" class='icons'></iconify-icon></a>
                 
                         <a href='https://codeforces.com/profile/Tortorise' target='blank'><iconify-icon icon="simple-icons:codeforces" class='icons'></iconify-icon></a>
                  <a href="https://leetcode.com/ashu_1244/" target='_blank' rel="noreferrer"><iconify-icon icon="simple-icons:leetcode"  class='icons'></iconify-icon></a>
                   <a href='https://www.linkedin.com/in/ashutosh-kumar-325353218/' target='_blank' rel="noreferrer"><i className='fab fa-linkedin'></i></a>
                        <a href='https://www.wikitechnify.com' target='_blank' rel="noreferrer"><i class="fa-solid fa-globe"></i></a>
                
             
                  
                       
                    </div>
                    </div>
                
                   
                </div>
            </div>

        </section>
    )

}


export default About;
